import { Link } from 'react-router-dom';

const quickLinks = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/services' },
  { label: 'About', to: '/about' },
  { label: 'Testimonials', to: '/testimonials' },
  { label: 'Contact', to: '/contact' },
];

export default function Footer() {
  return (
    <footer style={{ backgroundColor: '#070C18', borderTop: '1px solid rgba(204,0,0,0.25)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <img
              src="/logo.jpg"
              alt="Auto Doctor Ltd"
              style={{ height: '40px', width: 'auto', maxWidth: '160px', objectFit: 'contain', marginBottom: '12px' }}
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Waikanae's trusted mechanical workshop. Serving the Kapiti Coast with honest, quality automotive care.
            </p>
            {/* Facebook */}
            <a
              href="https://www.facebook.com/AutoDoctorLTDWaikanae/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded text-sm font-medium text-white transition-all duration-200"
              style={{ backgroundColor: '#CC0000' }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#AA0000'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#CC0000'; }}
            >
              <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
              Facebook
            </a>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="text-white font-semibold text-sm uppercase tracking-widest mb-4" style={{ color: '#CC0000' }}>
              Quick Links
            </h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-gray-400 text-sm hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact and hours */}
          <div>
            <h3 className="text-white font-semibold text-sm uppercase tracking-widest mb-4" style={{ color: '#CC0000' }}>
              Contact and Hours
            </h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="flex items-start gap-2">
                <span style={{ color: '#CC0000' }}>&#9679;</span>
                <span>22 Parata Street, Waikanae</span>
              </li>
              <li className="flex items-start gap-2">
                <span style={{ color: '#CC0000' }}>&#9679;</span>
                <a href="tel:042935987" className="hover:text-white transition-colors duration-200">04-293 5987</a>
              </li>
              <li className="flex items-start gap-2">
                <span style={{ color: '#CC0000' }}>&#9679;</span>
                <a href="mailto:admin@autodoctor.co.nz" className="hover:text-white transition-colors duration-200">admin@autodoctor.co.nz</a>
              </li>
            </ul>
            <div className="mt-4 pt-4 border-t border-white/10 text-sm text-gray-400 space-y-1">
              <p><span className="text-white">Mon to Fri:</span> 8:00am to 5:00pm</p>
              <p><span className="text-white">Saturday:</span> Closed</p>
              <p><span className="text-white">Sunday:</span> Closed</p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-gray-500">
          <div className="flex flex-col sm:flex-row items-center gap-1 sm:gap-4 text-center sm:text-left">
            <p>&copy; {new Date().getFullYear()} Auto Doctor Ltd. All rights reserved.</p>
            <Link to="/terms" className="hover:text-gray-300 transition-colors duration-200 underline underline-offset-2">
              Terms and Privacy
            </Link>
          </div>
          <p>22 Parata Street, Waikanae, Kapiti Coast</p>
        </div>

        {/* Site credit */}
        <div className="mt-4 flex justify-center sm:justify-end">
          <a
            href="https://irongate.co.nz"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[11px] text-gray-600 hover:text-gray-400 transition-colors duration-200"
          >
            Site by Irongate Digital
          </a>
        </div>
      </div>
    </footer>
  );
}
